import { render, staticRenderFns } from "./NavigationSubheader.vue?vue&type=template&id=2970e399&"
import script from "./NavigationSubheader.vue?vue&type=script&lang=js&"
export * from "./NavigationSubheader.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSubheader.vue?vue&type=style&index=0&id=2970e399&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
